import { Bounds, Point, Rectangle } from '@mathigon/euclid';
import { scheduledForEach } from './timerUtils';

export function getElementsWithClassNames( ...classNames ) {
	const selector = classNames.map( className => `.${className}` ).join( ',' );
	return Array.from( document.querySelectorAll( selector ) );
}

export function getElementRectangleInPageCoords( element ) {
	const { x, y, width, height } = element.getBoundingClientRect();
	const pageX = window.pageXOffset + x;
	const pageY = window.pageYOffset + y;

	return new Rectangle(
		new Point( pageX, pageY ),
		width,
		height
	);
}

export function getElementBoundsInPageCoords( element ) {
	const { left, right, top, bottom } = element.getBoundingClientRect();

	return new Bounds(
		window.pageXOffset + left,
		window.pageXOffset + right,
		window.pageYOffset + top,
		window.pageYOffset + bottom
	);
}

export function removeTextSelection() {
	document.getSelection().removeAllRanges();
}

export function disableTextSelection() {
	removeTextSelection();
	document.addEventListener( 'selectionchange', removeTextSelection );
}

export function reenableTextSelection() {
	document.removeEventListener( 'selectionchange', removeTextSelection );
}

export function changePointerEventsForElements( elements, { newValue, atClientY } ) {
	const isNearClientY = ( element ) => {
		const rect = element.getBoundingClientRect();
		const distance = Math.abs( rect.y + 0.5 * rect.height - atClientY );

		return distance < window.innerHeight;
	};

	const changeElementPointerEvents = ( element ) => {
		element.style.pointerEvents = newValue;
	}

	const [ nearbyElements, distantElements ] = elements.partition( isNearClientY );

	nearbyElements.forEach( changeElementPointerEvents );
	scheduledForEach( distantElements, changeElementPointerEvents );
}

function isElementEditableInput( element ) {
	const isInput = element instanceof HTMLInputElement;
	const hasEditableType = /|text|email|number|password|search|tel|url/.test( element?.type || '' );
	return isInput && hasEditableType;
}

export function isEditableElement( element ) {
	const hasEditableContent = element instanceof HTMLElement && element.isContentEditable;
	const isTextArea = element instanceof HTMLTextAreaElement;
	const isEditableInput = isElementEditableInput( element );

	return hasEditableContent || isTextArea || isEditableInput;
}

export function dispatchCustomEvent( type, detail ) {
	const event = new CustomEvent( type, {
		bubbles: true,
		cancelable: true,
		detail
	} );

	document.dispatchEvent( event );
}
